import React from "react"

import BaseSvgIcon from "../Base"

const SurveysNav = (props) => {
  return (
    <BaseSvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path
        d="M9 4H6.75A1.75 1.75 0 0 0 5 5.75v13.5A1.75 1.75 0 0 0 6.75 21h10.5A1.75 1.75 0 0 0 19 19.25V5.75A1.75 1.75 0 0 0 17.25 4H15"
        style={{fill: "none"}}
      />
      <rect x="9" y="2.25" width="6" height="3.6" rx="1.3" style={{fill: "none"}} />
      <path d="m7.9 11.6 1.3 1.3 2.4-2.6" style={{fill: "none"}} />
      <path d="M13.9 11.4h2.6" style={{fill: "none"}} />
      <path d="m7.9 16.5 1.3 1.3 2.4-2.6" style={{fill: "none"}} />
      <path d="M13.9 16.3h2.6" style={{fill: "none"}} />
    </BaseSvgIcon>
  )
}

export default SurveysNav
